import React, { useEffect } from "react";

import { MdDelete } from "react-icons/md";

import { ErrorWrapper, LoaderComponent } from "../decorate";

import { useGallery, useLoader } from "../../hooks";

import { deleteImage } from "../../actions";

function CustomGallery({ logo_url, style = {}, handleUrls = () => {} }) {
  const { recentUploads, getRecentUploads } = useGallery();
  const { isLoading, onLoader, offLoader } = useLoader();

  const onDelete = async (id) => {
    onLoader();
    try {
      const res = await deleteImage(id);
      if (res?.[0] === true) {
        getRecentUploads();
        handleUrls({
          logo_url: null,
          cropped_url: null,
        });
      }
    } catch (error) {
      console.error(error);
    } finally {
      offLoader();
    }
  };
  useEffect(() => {
    onLoader();
    offLoader();
  }, []);

  return (
    <div className="gallery-section">
      <span>Recent Logos</span>

      <div
        className="uploaded-images"
        style={{ ...style, ...(!recentUploads?.length ? { height: 250 } : {}) }}
      >
        {recentUploads?.length > 0 ? (
          recentUploads.map((e, i) => (
            <div
              key={i}
              style={{
                position: "relative",
                ...(isLoading ? { overflow: "hidden" } : {}),
                margin: 2,
                width: 100,
              }}
            >
              <LoaderComponent />
              <div
                key={i}
                className={`image-section ${
                  logo_url === e?.image_url ? "selected-image" : ""
                }`}
                onClick={() => {
                  handleUrls({
                    logo_url: e?.image_url || "",
                    cropped_url: e?.image_url || "",
                  });
                }}
              >
                {e?.image_url && <img src={e.image_url} alt="logo" />}

                <div
                  className="image-delete-icon"
                  onClick={() => onDelete(e.id)}
                  style={{ fontSize: 16 }}
                >
                  <MdDelete />
                </div>
              </div>
            </div>
          ))
        ) : (
          <div
            className="w-100"
            style={{
              fontSize: 12,
              color: "red",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            No Logos Found
          </div>
        )}
      </div>

      <ErrorWrapper name="upload" />
    </div>
  );
}

export default CustomGallery;
